export const dataHelpTourText = `You can contribute to the community by classifying the current variant
(as Benign, Pathogenic etc).
You may optionally add related diseases/phenotypes and your comments to the classification.`;
